/**
 * StatePanel — shared loading/empty/error placeholder for catalog widgets.
 */
import { Button } from "@melusine/shared-ui";

import styles from "./CatalogBrowser.module.css";

export interface StatePanelProps {
  readonly kind: "loading" | "empty" | "error";
  readonly message?: string;
  readonly onRetry?: () => void;
}

export function StatePanel({
  kind,
  message,
  onRetry,
}: StatePanelProps): JSX.Element {
  if (kind === "loading") {
    return (
      <div className={styles.state} role="status" aria-live="polite">
        <span className={styles.spinner} aria-hidden="true" />
        <span className={styles.stateText}>Загрузка…</span>
      </div>
    );
  }
  if (kind === "error") {
    return (
      <div className={styles.state} role="alert">
        <span className={styles.stateText}>
          {message ?? "Не удалось загрузить. Попробуйте ещё раз."}
        </span>
        {onRetry ? (
          <Button variant="secondary" size="sm" onClick={onRetry}>
            Повторить
          </Button>
        ) : null}
      </div>
    );
  }
  return (
    <div className={styles.state}>
      <span className={styles.stateText}>{message ?? "Пусто"}</span>
    </div>
  );
}
